import React from "react";
import { useNavigate } from "@leagueplatform/routing";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";

const { VITE_APP_ENV } = import.meta.env;
const isDevelopmentOrStaging =
  VITE_APP_ENV === "staging" ||
  VITE_APP_ENV === "development" ||
  import.meta.env.DEV;

export const DevToolsButton: React.FC = () => {
  const navigate = useNavigate();

  if (!isDevelopmentOrStaging) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => navigate(APP_MANAGED_ROUTES.MASONRY_PLAYGROUND)}
      aria-label="Open Masonry Playground"
      title="Masonry Playground"
      style={{
        position: "fixed",
        bottom: "70px",
        left: "16px",
        width: "40px",
        height: "40px",
        borderRadius: "8px",
        backgroundColor: "#1a1a1a",
        border: "none",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
        zIndex: 9999,
        transition: "transform 0.2s ease, background-color 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.1)";
        e.currentTarget.style.backgroundColor = "#333";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.backgroundColor = "#1a1a1a";
      }}
    >
      {/* Masonry/Grid Icon */}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="3" y="3" width="7" height="9" rx="1" fill="#cb04f3" />
        <rect x="3" y="14" width="7" height="7" rx="1" fill="#cb04f3" />
        <rect x="12" y="3" width="9" height="7" rx="1" fill="#cb04f3" />
        <rect x="12" y="12" width="9" height="9" rx="1" fill="#cb04f3" />
      </svg>
    </button>
  );
};
